import React, { useEffect, useState } from 'react';
import { Calendar as BigCalendar, momentLocalizer } from 'react-big-calendar';

import EventDay from './components/EventDay';
import EventMonth from './components/EventMonth';
import DateCellHeader from './components/DateCellHeaderView';
import styled from 'styled-components';
import { CircularProgress } from '@mui/material';
import { useDispatch } from 'react-redux';
import { actions as calendarActions } from '../../services/calendar/index';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import EventDayWrapper from './components/EventDayWrapper';

const DnDCalendar = BigCalendar;

function Calendar(props) {
  const { t } = useTranslation();
  const {
    workHours = [],
    selectedEvent,
    connectedComponents = {},
    onRangeChange,
    openEventDialog,
    openDetailsDialog,
    highlightEvent,
    updateEvent,
    loading,
    events,
    getVisibleTimePeriod,
    ...calendarData
  } = props;

  const dispatch = useDispatch();

  const [selectedDay, setSelectedDay] = useState(new Date());
  const [currentView, setCurrentView] = useState(calendarData?.defaultView);

  const [minMax, setMinMax] = useState(
    currentView === 'day'
      ? getVisibleTimePeriod(workHours, selectedDay)
      : getVisibleTimePeriod(workHours)
  );

  useEffect(() => {
    if (currentView === 'day') {
      setMinMax(getVisibleTimePeriod(workHours, selectedDay));
      return;
    }
    setMinMax(getVisibleTimePeriod(workHours));
  }, [selectedDay, workHours, currentView]);

  const onUpdateEvent = (data) => {
    updateEvent({
      ...data.event,
      start: data.start,
      end: data.end,
    });
  };

  const onView = (view) => {
    setCurrentView(view);
  };

  const onNavigate = (date, view) => {
    dispatch(calendarActions.setCurrentView({ view }));
    if (view === 'day') {
      setMinMax(getVisibleTimePeriod(workHours, date));
      setSelectedDay(date);
    } else {
      setMinMax(getVisibleTimePeriod(workHours));
    }
    highlightEvent({ eventId: null, date });
  };

  const onSelectEvent = (event) => {
    setSelectedDay(new Date(event.startDate));
    dispatch(calendarActions.highlightEvent({ eventId: event.id }));
    openDetailsDialog(event);
  };

  const onSelecting = (props) => {};
  const onSelectSlot = (data) => {
    // openEventDialog(data);
  };

  let calendarComponents = {
    event: EventDay,
    toolbar: connectedComponents.ToolbarView,
    dateCellWrapper: connectedComponents.DateCellWrapper,
    timeSlotWrapper: connectedComponents.TimeSlotWrapper,
    month: {
      event: EventMonth,
      dateHeader: DateCellHeader,
      header: ({ label }) => t(label),
    },
    week: {
      eventWrapper: EventDayWrapper,
      header: ({ date }) => `${format(date, 'dd')} ${t(format(date, 'EEE'))}`,
    },
    day: {
      eventWrapper: EventDayWrapper,
      header: ({ date }) => `${format(date, 'dd')} ${t(format(date, 'EEE'))}`,
    },
  };

  const getDate = (date) => {
    const res = new Date(date);
    return res;
    // todo: fix this part
  };

  return (
    <div
      style={{
        position: 'relative',
      }}
    >
      <DnDCalendar
        min={minMax?.min ?? undefined}
        max={minMax?.max ?? undefined}
        dayLayoutAlgorithm="no-overlap"
        resizable
        selectable
        events={events}
        step={30}
        timeslots={2}
        showMultiDayTimes
        components={calendarComponents}
        style={{ height: '95vh' }}
        defaultDate={selectedDay}
        selected={
          selectedEvent && selectedEvent.eventId
            ? props.events[selectedEvent.eventId]
            : undefined
        }
        startAccessor={(event) => getDate(event.startDate)}
        endAccessor={(event) => getDate(event.endDate)}
        onSelectEvent={onSelectEvent}
        onEventResize={onUpdateEvent}
        onEventDrop={onUpdateEvent}
        onSelectSlot={onSelectSlot}
        onSelecting={onSelecting}
        onNavigate={onNavigate}
        onRangeChange={onRangeChange}
        onView={onView}
        {...calendarData}
        messages={{
          date: t('Date'),
          time: t('Time'),
          event: t('Event'),
          allDay: t('All Day'),
          week: t('Week'),
          work_week: t('Work Week'),
          day: t('Day'),
          month: t('Month'),
          previous: t('Back'),
          next: t('Next'),
          yesterday: t('Yesterday'),
          tomorrow: t('Tomorrow'),
          today: t('Today'),
          agenda: t('Agenda'),
          noEventsInRange: t('There are no events in this range.'),
        }}
      />

      {loading && (
        <SpinnerWrap>
          <CircularProgress size={35} />
        </SpinnerWrap>
      )}
    </div>
  );
}

export default Calendar;

const SpinnerWrap = styled.div`
  position: absolute;
  height: inherit;
  background-color: white;
  opacity: 0.7;
  width: 100%;
  top: 64px;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  z-index: 10;
  border-radius: 18px;

  &:hover {
    pointer-events: none;
  }
`;
